import { IconButton, AppBar, Toolbar, Tabs, Tab, Icon, Tooltip } from "@material-ui/core";
import * as React from "react";
import { VisibilityOutlined, Check, Edit, MoreVert } from "@material-ui/icons";
import { Theme } from "@material-ui/core/styles";

import { observable, action, toJS } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { Route, RouteComponentProps, Switch } from "react-router";

import { config } from "../../../../../src/config";
import { authStore } from "../../../../../src/modules/auth";
import { observer } from "mobx-react";
import { usersAdminStore } from ".";

import { history } from "../../../../history"
import { Loading } from "../../../../components/loading";

import { MaterialSwitch } from "./switch";

import { default as ReactTable, ReactTableDefaults } from "react-table";
import "react-table/react-table.css";

import { UsersAdminDetails } from "./components";
import { AdminToolBar } from "../../components";
import { permissionsStore } from '../Permissions';
import { companiesAdminStore } from '../CompaniesAdmin';
import "../UsersAdmin/actionBtn.css";

const styles = ({ typography }: Theme) =>
  createStyles({
    // root: {
    //   height: "100%",
    //   width: "100%",
    //   display: "flex",
    //   flexDirection: "column",
    //   overflow: 'hidden'
    // },
    // table: {
    //   height: "100%",
    //   flex: 1,
    //   fontFamily: "inherit",
    // },
    tableIconCell: {
      display: "flex",
      justifyContent: "center",
    },
    // tableIconHeader: {
    //   marginRight: "1rem",
    // },
    tableDefaultCell: {
      // marginRight: ".25rem",
      // marginLeft: ".25rem",
      display: "flex",
      alignItems: "center",
      fontFamily: typography.fontFamily,
    },
    tableDefaultHeader: {
      fontFamily: typography.fontFamily,
    },
    // content: {
    //   flex: 1,
    //   display: "flex",
    // },
    btnPosition: {
      marginLeft: '89%'
    }

  });

  interface IProps {
  }

  interface IState {
    filters?: any;
    anchorEl?: any;
    open: any;
    authId: any;
    colClicked: any;
  }

@observer
class UsersAdmin extends React.Component<any, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      filters: {},
      open: null,
      anchorEl: null,
      authId: null,
      colClicked: null,
    };
  }

  @observable
  public module: "table" | "details";

  @observable
  public loaded: boolean = false;

  @observable
  public data: any;

  @observable
  public showDisabled: boolean = false;

  /**
   * #TODO E-019 TMPS > Users & Companies - set the previous
   */
  protected columns = [
    {
      Header: "Name",
      accessor: "FullName",
      Filter: ({ filter, onChange }) => (
        <input
          type="text"
          style={{width: '100%'}}
          defaultValue={filter ? filter.value : this.state.filters['FullName']}
          onKeyUp={(event) => {
            onChange(event.currentTarget.value)
            if(event.currentTarget.value.length === 0){
              let filterInfo:any = localStorage.getItem('filter')
              let filter:any = JSON.parse(filterInfo)
              delete filter.FullName
              localStorage.setItem('filter', JSON.stringify(filter))
            }
          }}
        />
      ),
    },
    {
      Header: "Email",
      accessor: "Email",
      Filter: ({ filter, onChange }) => (
        <input
          type="text"
          style={{width: '100%'}}
          defaultValue={filter ? filter.value : this.state.filters['Email']}
          onKeyUp={(event) => {
            onChange(event.currentTarget.value)
            if(event.currentTarget.value.length === 0){
              let filterInfo:any = localStorage.getItem('filter')
              let filter:any = JSON.parse(filterInfo)
              delete filter.Email
              localStorage.setItem('filter', JSON.stringify(filter))
            }
          }}
        />
      ),
    },
    {
      Header: "Companies",
      accessor: (a: any) => this.companyColumn(a),
      id: 'companies',
      Filter: ({ filter, onChange }) => (
        <input
          type="text"
          style={{width: '100%'}}
          defaultValue={filter ? filter.value : this.state.filters['companies']}
          onKeyUp={(event) => {
            onChange(event.currentTarget.value)
            if(event.currentTarget.value.length === 0){
              let filterInfo:any = localStorage.getItem('filter')
              let filter:any = JSON.parse(filterInfo)
              delete filter.companies
              localStorage.setItem('filter', JSON.stringify(filter))
            }
          }}
        />
      ),
    },
    {
      Header: "Pharmacy",
      accessor: (a: any) => this.pharmacyContentHover(a),
      id: "sites",
      filterable: true,
      fontFamily: "Roboto Helvetica Arial",
    },

    {
      Header: "Portal Role",
      accessor: "PortalRoleName",
      width: 110,
      Filter: ({ filter, onChange }) => (
        <input
          type="text"
          style={{width: '100%'}}
          defaultValue={filter ? filter.value : this.state.filters['PortalRoleName']}
          onKeyUp={(event)=>{
            onChange(event.currentTarget.value)
            if(event.currentTarget.value.length === 0){
              let filterInfo:any = localStorage.getItem('filter')
              let filter:any = JSON.parse(filterInfo)
              delete filter.PortalRoleName
              localStorage.setItem('filter', JSON.stringify(filter))
            }
          }}
        />
      ),

    },
    {
      Header: 'University',
      accessor: (a: any) => this.universityColumn(a),
      id: 'University',
      // className: this.props.classes.tableIconCell,
      resizable: true,
      filterable: false,
      width: 90,
    },
    {
      Header: 'Pharmacy',
      accessor: (a: any) => this.pharmacyColumn(a),
      id: 'Pharmacy',
      // className: this.props.classes.tableIconCell,
      resizable: true,
      filterable: false,
      width: 95,
    },
    {
      Header: "Actions",
      accessor: (a: any) => this.actionBtnInUserList(a),
      id: "auth_id",
      className: this.props.classes.tableIconCell,
      sortable: false,
      resizable: true,
      filterable: false,
      width: 90,
      alignItems: "center",
      show: permissionsStore.checkPermissionByCategoryAndType("user", "update"),
    },

  ];


  public componentDidMount = async () => {
    usersAdminStore.setBlankUser();
    await usersAdminStore.retrieveUsers();
    await usersAdminStore.getAllAvailableRoles();
    this.forceUpdate()
    let data: any = localStorage.getItem('filter');
    let val:any = JSON.parse(data);
    if(val){
      this.setState({filters: val})
    }
  }

  public universityModifiedRole = (row: any) => {
    let value: any;
    const u = row.appRoles[1].roles;
    const minId = Math.min(...u?.map(obj => obj.role_id));
    const filteredArray = u?.filter(obj => obj.role_id === minId);
    filteredArray.map(item => {
      value = item.UniversityRoleName;
    });
    return value;
  };

  public universityColumn = (row: any) => {
    return this.universityModifiedRole(row);
  }

  public pharmacyColumn = (row: any) => {
    if (row.PharmacyAccess === 1) {
      const pharmaRole = row.appRoles.find((role: any) => role.app_id === 1);
      return pharmaRole?.roles[0]?.PharmacyRoleName;
    }
    return null;
  }

  public companyColumn = (row: any) => {
    if (row.Companies.length === 0) {
      return null
    }
    else if (row.Companies.length === 1) {
      console.log(row.Companies[0].CompanyName,"row.Companies")

      return row.Companies[0].CompanyName
    }
    else {
      const compArr = row.Companies.map((c: any) => ` ${c.CompanyName}`);
      const compString = compArr.join();
      console.log(compString.substring(0, compString.length - 1),"row.Companies")
      return compString.substring(0, compString.length - 1)
    }
  }

  public actionBtnInUserList = (row: any) => {
    const viewUser = authStore.currentUser.PermissionsList.filter(
      (val: any) => {
        if (val.PermissionType === "view") {
          return true;
        }
      }
    );
    
    return (
      <>
        <label className="dropdown">
          <div className="dd-button">
            <MoreVert fontSize="small" />
          </div>
          <input type="checkbox" className="dd-input" id="test" />
          <ul className="dd-menu">
            <li>
              <div
                style={{
                  display: `flex`,
                  flexDirection: "row",
                }}
              >
                <IconButton
                  color={"default"}
                  onClick={this.navOnClick(`/admin/users/edit/${row.auth_id}`)}
                  style={{ padding: ".375rem" }}
                >
                  <Edit fontSize="small" />
                </IconButton>

                {viewUser.length > 0 && (
                  <IconButton
                    color={"default"}
                    onClick={this.navOnClick(
                      `/admin/users/detail/${row.auth_id}`
                    )}
                    style={{ padding: ".375rem" }}
                  >
                    <VisibilityOutlined fontSize="small" />
                  </IconButton>
                )}
              </div>
            </li>
          </ul>
        </label>
      </>
    );
  };

  public pharmacyContentHover = (row: any) => {
    let compArr: any;
    if (row.PharmacyAccess === 1) {
      compArr = row.sites.map(p => `${p.displayName}`);
      const compString = compArr.join();
      return compString.substring(0, compString.length);
    }
    return null;
  };

  public filterCaseInsensitive = (filter: any, row: any) => {
    const id = filter.pivotId || filter.id;
    const content = row[id];
    if (typeof content !== 'undefined') {
      // filter by text in the table or if it's a object, filter by key
      if (typeof content === 'object' && content !== null && content.key) {
        return String(content.key).toLowerCase().includes(filter.value.toLowerCase());
      } else {
        return String(content).toLowerCase().includes(filter.value.toLowerCase());
      }
    }
    return true;
  };

  public handleFilterChange = (columnId, value) => {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        [columnId]: value,
      },
    }));
  };

  public navOnClick = (link: string) => (e: React.MouseEvent): void => {
    history.push(link);
  };

  /**
   * function to handle toggle show disabled button in user list
   */
  public handleToggleBtn = () => {
    console.log(usersAdminStore.all_users)
    this.showDisabled = !this.showDisabled
    usersAdminStore.retrieveUsers()
    history.push("/admin/users")
  }

  /**
   * function to handle styling of the disabled users while click on the button
   */
  getTrProps = (state, rowInfo, instance) => {
    if (rowInfo) {
      return {
        style: {
          background: rowInfo
            ? rowInfo.original.PortalDeletedAt !== null
              ? "#a9a9a9"
              : "none"
            : "none"
        }
      };
    }
    return {};
  };

  public render() {
    if(Object.entries(this.state.filters).length != 0){
      localStorage.setItem('filter', JSON.stringify(this.state.filters));
    }

    const { classes } = this.props;
    if (!usersAdminStore.loaded) {
      return <Loading />;
    }

    let style = {
      color: "green"
    }

    return (
      <div className={classes.root}>
        <AdminToolBar pageTitle={'Users'} />
        <div className={classes.content}>
          <Switch>
            <Route path={"/admin/users"} render={this.tableRender}/>
          </Switch>
        </div>
      </div>
    );
  };

  protected tableRender = () => {
    const { filters } = this.state;

    const currentUserCom = authStore?.currentUser?.Companies; // B-118
    const currentUserSite = authStore?.currentUser?.Sites; // B-118
    // B-118
    const filteredUserData = usersAdminStore?.all_users?.map((users) => {
      return {
        ...users,
        Companies: users.Companies.filter((company:any) =>
          currentUserCom.some(item => item.company_id === company.company_id)
        ),
        sites: users.sites.filter((site:any) =>
          currentUserSite.some(item => item.siteId === site.siteId)
        )
      }
    }).filter((user) => user.Companies.length > 0 && user.sites.length > 0);

    // B-118
    const finalUsersData =
      authStore?.currentUser?.portal_role_id === 1 ||
      authStore?.currentUser?.portal_role_id === 2
        ? usersAdminStore?.all_users
        : filteredUserData;


    if (usersAdminStore.loaded) {
      return (
        <>
       {(permissionsStore.checkPermissionByCategoryAndType('user', 'update') || permissionsStore.checkPermissionByCategoryAndType('user', 'delete')) &&( //C-024
       <div className={this.props.classes.btnPosition}>
       <MaterialSwitch
                  label={"Show Disabled"}
                  value="true"
                  // checked={switchChecked2}
                  onChange={this.handleToggleBtn}
                  disabled={authStore?.currentUser?.ViewingRole==6 ? true:false}

          />
       </div>
       )}
        <ReactTable
          column={{
            ...ReactTableDefaults.column,
            resizable: true,
            // filterable: true,
            className: this.props.classes.tableDefaultCell,
            headerClassName: this.props.classes.tableDefaultHeader,
          }}
          data={this.showDisabled === false ? finalUsersData?.filter(item=> item.PortalDeletedAt === null) : finalUsersData} // B-118
          columns={this.columns}
          style={{ height: "70%", flex: 1 }}
          className="-striped -highlight user-table" // C-120_UAT
          filterable={true}
          getTrProps={this.getTrProps}
          defaultFilterMethod={this.filterCaseInsensitive}
          filtered={Object.entries(filters).map(([columnId, value]) => ({
            id: columnId,
            value: value,
          }))}
          onFilteredChange={(filtered) => {
            const newFilters = {};
            filtered.forEach((filter) => {
              newFilters[filter.id] = filter.value;
            });
            this.setState({ filters: newFilters });
          }}
        />
        </>
      );
    } else {
      return <Loading />;
    }
  };

  protected detailsRender = (mode: string) => () => {
    return <UsersAdminDetails mode={mode} />;
  };
}

export default withStyles(styles, { withTheme: true })(UsersAdmin);



// WEBPACK FOOTER //
// ./src/modules/admin/modules/UsersAdmin/UsersAdmin.tsx